<div class="sheet-wrapper">

    <button class="close-btn" (click)="close()">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
                d="M11.0741 0.0284462C11.4727 0.125681 11.815 0.474303 11.9065 0.872727C11.9721 1.15732 11.9229 1.49171 11.7799 1.73598C11.747 1.79053 10.7974 2.76762 9.66953 3.90835L7.61546 5.98347L9.69766 8.09418C11.9393 10.3661 11.8783 10.2974 11.9651 10.6318C12.0331 10.9045 11.9956 11.1867 11.8549 11.4547C11.6345 11.8745 11.1163 12.0784 10.5676 11.9622C10.2393 11.8911 10.3261 11.9693 8.09615 9.71634C6.96126 8.57086 6.02099 7.63172 6.00926 7.63172C5.99754 7.63172 5.05727 8.56849 3.92238 9.71634C2.00901 11.6492 1.84721 11.8057 1.70652 11.8721C1.22115 12.0998 0.634943 12.0073 0.299634 11.6492C-0.0169163 11.3124 -0.0896063 10.7954 0.116738 10.3614C0.184738 10.2167 0.348875 10.046 2.29038 8.08943L4.39134 5.97636L2.349 3.9036C1.07577 2.61346 0.28322 1.7929 0.245703 1.72649C0.142531 1.54151 0.105014 1.36602 0.116738 1.11226C0.130807 0.839525 0.187082 0.673515 0.334806 0.474303C0.623219 0.0877361 1.14611 -0.0759029 1.60101 0.0806208C1.86128 0.168369 1.97852 0.279833 4.01382 2.34073L6.00692 4.35657L8.05864 2.28856C10.2651 0.0687628 10.2112 0.116195 10.5348 0.030818C10.6966 -0.0118704 10.9099 -0.0118704 11.0741 0.0284462Z"
                fill="#A5ACB0" />
        </svg>
    </button>

    <div class="theme-card">
        <div class="col-md-12">
            <div class="img-fluid imgContainer">
                <img loading="lazy" decoding="async" [src]="theme.cardImg" [alt]="theme.title" class="themee-image" />
            </div>
            <h3>{{ theme.title }}</h3>
            <p class="subtitle">{{ theme.subtitle }}</p>

            <h5>This space helps you</h5>
            <ul class="help-list">
                <li *ngFor="let help of theme.helps">
                    {{ help }}
                </li>
            </ul>

            <h5>Program format</h5>
            <p class="program-text">
                {{ theme.format }}
            </p>

            <div class="">
                <!-- <img loading="lazy" decoding="async" [src]="theme.cardImg" [alt]="theme.title" class="theme-image" /> -->
                <button class="contact-btn d-block d-md-none mt-3" (click)="scrollToContact()">
                    Contact Us
                </button>
            </div>

        </div>
    </div>

</div>